import { laborHoursConstant } from './constant';

export const getAllLaborHours = (payload: any) => {
  return {
    type: laborHoursConstant.GET_LABOR_HOURS_REQUEST,
    payload,
  };
};
export const getAllLaborCodes = () => {
  return {
    type: laborHoursConstant.GET_LABOR_CODES_REQUEST,
  };
};

export const addLaborHoursAction = (payload: any) => {
  return {
    type: laborHoursConstant.ADD_LABOR_HOURS_REQUEST,
    payload,
  };
};

export const editLaborHoursAction = (payload: any) => {
  return {
    type: laborHoursConstant.EDIT_LABOR_HOURS_REQUEST,
    payload,
  };
};

export const getLocationTypeLaborHr = () => {
  return {
    type: laborHoursConstant.GET_LOCATION_TYPE_REQUEST,
  };
};

export const resetAddLaborHoursAction = () => {
  return {
    type: laborHoursConstant.ADD_LABOR_HOURS_RESET,
  };
};

export const resetEditLaborHoursAction = () => {
  return {
    type: laborHoursConstant.EDIT_LABOR_HOURS_RESET,
  };
};

export const deleteLaborHoursAction = (payload: any) => {
  return {
    type: laborHoursConstant.DELETE_LABOR_HOURS_REQUEST,
    payload,
  };
};

export const resetDeleteLaborHoursAction = () => {
  return {
    type: laborHoursConstant.DELETE_LABOR_HOURS_RESET,
  };
};

export const getLaborReportAction = (payload: any) => {
  return {
    type: laborHoursConstant.GET_LABOR_REPORT_REQUEST,
    payload,
  };
};

export const resetLaborReportAction = () => {
  return {
    type: laborHoursConstant.GET_LABOR_REPORT_RESET,
  };
};

export const getBuildingsOverviewAction = (payload: any) => {
  return {
    type: laborHoursConstant.GET_BUILDINGS_OVERVIEW_REQUEST,
    payload,
  };
};

export const resetBuildingsOverviewAction = () => {
  return {
    type: laborHoursConstant.GET_BUILDINGS_OVERVIEW_RESET,
  };
};

export const getLaborEntryHistoryAction = (payload: any) => {
  return {
    type: laborHoursConstant.GET_LABOR_ENTRY_HISTORY_REQUEST,
    payload,
  };
};

export const resetLaborEntryHistoryAction = () => {
  return {
    type: laborHoursConstant.GET_LABOR_ENTRY_HISTORY_RESET,
  };
};

export const updateLaborEntryStatusAction = (payload: any) => {
  return {
    type: laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_REQUEST,
    payload,
  };
};

export const resetLaborEntryStatusAction = () => {
  return {
    type: laborHoursConstant.UPDATE_LABOR_ENTRY_STATUS_RESET,
  };
};

export const getLaborValidationToggleAction = () => {
  return {
    type: laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_REQUEST,
  };
};

export const getPayPeriodCyclesAction = (payload?: any) => {
  return {
    type: laborHoursConstant.GET_PAY_PERIOD_CYCLES_REQUEST,
    payload,
  };
};

export const getPayPeriodByDateAction = (payload: any) => {
  return {
    type: laborHoursConstant.GET_PAY_PERIOD_BY_DATE_REQUEST,
    payload,
  };
};

export const resetPayPeriodByDateAction = () => {
  return {
    type: laborHoursConstant.GET_PAY_PERIOD_BY_DATE_RESET,
  };
};

export const approvePayPeriodAction = (payload: any) => {
  return {
    type: laborHoursConstant.APPROVE_PAY_PERIOD_REQUEST,
    payload,
  };
};

export const resetApprovePayPeriodAction = () => {
  return {
    type: laborHoursConstant.APPROVE_PAY_PERIOD_RESET,
  };
};

export const resetPayPeriodCyclesAction = () => {
  return {
    type: laborHoursConstant.GET_PAY_PERIOD_CYCLES_RESET,
  };
};
